import {
  CreditCard,
  Banknote,
  Landmark,
  type LucideIcon,
  PenTool,
  ArrowLeftRight,
} from "lucide-react";

export const CONTRACT_ALERT_METHODS = ["CALL", "SMS", "EMAIL"] as const;

export type ContractAlertMethod = (typeof CONTRACT_ALERT_METHODS)[number];

export const CONTRACT_ALERT_METHOD_OPTIONS = CONTRACT_ALERT_METHODS.map(
  (method) => ({
    value: method,
  })
);

const PAYMENT_METHOD_ICON_BY_ID: Record<string, LucideIcon> = {
  "500": CreditCard,  // CREDIT CARD
  "501": PenTool, // CHECK
  "502": Banknote,  // CASH
  "503": CreditCard,  // PAYPAL
  "504": ArrowLeftRight,  // ETRANSFER
  "505": Landmark,  // DIRECT_DEPOSIT
};

export const getPaymentMethodIcon = (id: string): LucideIcon => {
  return PAYMENT_METHOD_ICON_BY_ID[id] ?? CreditCard;
};
